module.exports = __webpack_public_path__ + "hinted-OpenSans-Extrabold.c4d114bd4eef32d4512a.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSans-Extrabold.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSans-Extrabold.woff
// module chunks = 1